import { Chart } from "primereact/chart";
import { useContext, useEffect, useState } from "react";
import OverviewService from "../../service/OverviewService";
import AuthContext from "../../context";
import { useTranslation } from "react-i18next";
import { sortArrayD } from "../../utilities/general";

const NormStats = (props) => {
    const { startDate, endDate } = props
    const overviewService = new OverviewService();
    const authContext = useContext(AuthContext);
    const { t } = useTranslation();

    const [lightOptions] = useState({
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        }
    });
    const [normChartData, setNormChartData] = useState({
        labels: [],
        datasets: [
        ]
    });
    useEffect(() => {
        let searchOverviewData = {
            cateringId: authContext?.cateringId,
            startDate: startDate,
            endDate: endDate,

        }
        let listOfColors = ["#42A5F5", "#66BB6A", '#1e37bd', "#66ccff", "#cc6600", "#ff99ff"]

        overviewService.getCountOfNormsByCatering(searchOverviewData).then(data => {
            let sortedData = sortArrayD(data, 'currentAmount')
            let labels = sortedData.map(x => x.stockItemDTO.name)
            let dataForChart = sortedData.map(x => x.currentAmount)
            let dataSet = [{
                data: dataForChart,
                backgroundColor: listOfColors
            }
            ]
            let newChartData = {...normChartData }
            newChartData.datasets = dataSet
            newChartData.labels = labels
          
            setNormChartData(newChartData)
        })

    }, [startDate, endDate])
    return (
        <div className="card">
            <h5>{t('norms')}</h5>
            <Chart type="pie" data={normChartData} options={lightOptions} />
        </div>
    );
}

export default NormStats;